<template>
  <div class="detail-emoji-bar">
    <div
      v-for="emoji in detail.emoji || []"
      :key="emoji.id"
      class="emoji"
      :style="{ 'border-color': likeStyle(emoji) }"
      :class="{ isDark: isDark }"
      @click="handleClick(emoji)"
    >
      <img :src="emoji.icon" alt="" />
      <span :style="{ color: emoji.is_like ? '#0ac7fe' : isDark ? '#ffffff' : '#333333' }">{{ emoji.count }}</span>
    </div>
  </div>
</template>
<script>
import { apiContentEmojiLike } from "@/api/gameApi";

export default {
  name: "DetailEmojiBar",
  props: {
    detail: { type: Object, default: () => ({}) },
    isDark: { type: Boolean, default: false }
  },
  methods: {
    handleClick(emoji) {
      emoji.is_like = !emoji.is_like;
      if (emoji.is_like) {
        this.protrudeTop(emoji.icon);
        emoji.count++;
        this.$emit("emojiCheck");
      } else {
        emoji.count--;
      }
      apiContentEmojiLike({ content_id: this.detail.id, emoji_id: emoji.id, is_like: emoji.is_like });
      this.clearOtherLike(emoji);
    },
    protrudeTop(icon) {
      const rm = document.querySelector("body > img.__content-emoji-protrude-top-class__");
      rm && rm.remove();

      const img = document.createElement("img");
      img.src = icon;
      img.classList.add("__content-emoji-protrude-top-class__");
      document.body.appendChild(img);
      setTimeout(() => {
        img.remove();
      }, 2000);
    },
    clearOtherLike(emoji) {
      this.detail.emoji.forEach(item => {
        if (item.id !== emoji.id) {
          if (item.is_like) {
            item.count--;
          }
          item.is_like = false;
        }
      });
    },
    likeStyle(emoji) {
      if (emoji.is_like) {
        if (this.isDark) {
          return "rgba(30,133,201,0.64)";
        } else {
          return "#0ac7fe";
        }
      } else {
        if (this.isDark) {
          return "rgba(240,241,245,0.04)";
        } else {
          return "#f0f1f5";
        }
      }
    }
  }
};
</script>
<style>
.__content-emoji-protrude-top-class__ {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2000;
  width: 10vw;
}
</style>
<style lang="less" scoped>
.detail-emoji-bar {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  .emoji {
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 8px;
    width: 152px;
    //height: 48px;
    padding: 10px 0;
    border-radius: 4px;
    user-select: none;
    cursor: pointer;
    border: 1px solid #f0f1f5;
    img {
      height: 60px;
    }
    span {
      font-size: 12px;
      color: #333333;
    }
  }
}
</style>
